import React, { Component } from 'react'
import { FlowTable } from 'components/basic'

class JsonRender extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  }

  componentDidMount () {
    this.setState({data: this.props.data})
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({data: props.data})
  }

  renderTree (children, count, level) {
    if (!children) return <div></div>
    if (!count) count = 0
    if (!level) level = 0
    let buffer = []

    level++
    var objectRows = []
    var objectData = []
    for (let key in children) {
      if (!children.hasOwnProperty(key)) {
        continue
      }
      let value = children[key]
      count++

      if (['string', 'boolean', 'number'].includes(typeof value) || value.hasOwnProperty('styles')) {
        objectRows.push(<th key={key + Math.random()}>{key}</th>)
        value.hasOwnProperty('value') ? value.hasOwnProperty('styles') ? objectData.push(<td style={value.styles} key={value.value + Math.random()}>{value.value}</td>) : objectData.push(<td key={value.value + Math.random()}>{value.value}</td>) : objectData.push(<td key={value + Math.random()}>{value}</td>)
        continue
      }

      if (this.isTable(value)) {
        buffer.unshift(
          <div key={count}>
            <span className='child-level-text'>{key} <i className='fa fa-rotate-90 fa-mail-forward' /></span>
            <pre style={{overflow: 'hidden', 'padding': 0, 'paddingLeft': '10px'}}>
              <FlowTable data={value.map(row => Object.values(row).map(
                  value => value.hasOwnProperty('value') ? value.hasOwnProperty('styles') ? {style: value.styles, content: value.value} : value.value : value
                ).reverse())}>
                <tr>
                  {Object.keys(value[0]).map(key => <th key={count + '_' + key}>{key}</th>).reverse()}
                </tr>
              </FlowTable>
            </pre>
          </div>
        )
      } else {
        buffer.push(
          <div className={(level === 1 ? 'top-level-header' : 'margin-left-20')} key={count}>
            {(level === 1 ? <span className='top-level-text label label-primary'><i className='fa fa-fw fa-wrench' />{key}</span> : <span className='child-level-text'>{key} <i className='fa fa-rotate-90 fa-mail-forward' /></span>)}
            {this.renderTree(value, count, level)}
          </div>
        )
      }
    }

    if (objectRows.length !== 0) {
      buffer.unshift(
        <div key={count + Math.random() + Date.now()}>
          <pre style={{overflow: 'hidden', 'padding': '0px'}}>
            <table className='table' id='sortable-table' >
              <thead><tr>{objectRows.map(row => row)}</tr></thead>
              <tbody>
                <tr>
                  {objectData.map(data => data)}
                </tr>
              </tbody>
            </table>
          </pre>
        </div>
      )
    }
    return buffer
  }

  arrayEqual (a, b) {
    let l = a.length
    if (l !== b.length) {
      return false
    }
    while (--l) {
      if (a[l] !== b[l]) {
        return false
      }
    }
    return true
  }

  isTable (a) {
    if (!Array.isArray(a)) {
      if (a.hasOwnProperty('styles') && a.hasOwnProperty('value')) {
        this.isTable(a.value)
      }
      return false
    }
    if (a.length === 0) {
      return false
    }

    if (typeof a[0] !== 'object') {
      return false
    }
    let headers = Object.keys(a[0])
    let l = headers.length
    while (l--) {
      if (!['string', 'number'].includes(typeof headers[l])) {
        return false
      }
    }

    l = a.length
    while (l--) {
      if (!this.arrayEqual(headers, Object.keys(a[l]))) {
        return false
      }
      let values = Object.values(a[l]).map(value => value.hasOwnProperty('value') ? value.value : value)
      let x = values.length

      while (x--) {
        if (!['string', 'number'].includes(typeof values[x])) {
          return false
        }
      }
    }
    return true
  }

  render () {
    return (
      <div>
        {this.renderTree(this.state.data)}
      </div>
    )
  }
}

export default JsonRender



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/JsonRender.js